import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";

import { useIsMobile, useCurrentFullAssistantPage } from "@hooks";
import useAppStore from "../../stores/appStore";
import { selectedAssistantSelector, assistantIdSelector } from "../../stores/selectors/appSelectors";
import AssistantHeader from "../Content/AssistantHeader";
import ErrorBoundary from "../ErrorBoundries";
import { AppWrapper, ContentWrapper } from "../LayoutWrappers";
import NavigationBar from "../Navigation/NavigationBar";
import OutletWithErrorHandling from "../OutletWithErrorHandling";
import { isFullyCodelessAgent } from "@utils";
import { ASSISTANT_CHANNELS, COLLECTION_PAGES, HOME } from "@consts";
import useNavigationProps from "src/layout/Navigation/NavigationBar.hook";
import { useTheme } from "@mui/material";
import { NAVIGATION_MODES } from "src/layout/Navigation/NavigationBar.consts";

const AssistantLayout = () => {
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useIsMobile();
  const pageName = useAppStore(state => state.pageName);
  const assistantId = useAppStore(assistantIdSelector);
  const isCollectionPage = COLLECTION_PAGES.includes(pageName);
  const displayGreyBackground = (selectedAssistant?.channel !== ASSISTANT_CHANNELS.WEB && pageName === HOME && isFullyCodelessAgent(assistantId)) || isCollectionPage;
  const navigationProps = useNavigationProps(NAVIGATION_MODES.ASSISTANT);

  return (
    <div style={{ display: "flex" }}>
      {!isMobile && (
        <NavigationBar
          {...navigationProps}
          useCurrentPage={useCurrentFullAssistantPage}
        />
      )}
      <Suspense>
        <AppWrapper className="app" statusBarDisplayed={navigationProps.showStatusBar}
          sx={{ backgroundColor: displayGreyBackground ? theme.palette.grey[50] : "#FFFFFF" }}>
          <ContentWrapper component="main">
            <ErrorBoundary key={location.pathname}>
              <AssistantHeader {...navigationProps} />
              <OutletWithErrorHandling />
            </ErrorBoundary>
          </ContentWrapper>
        </AppWrapper>
      </Suspense>
    </div>
  );
};

export default AssistantLayout;
